/// <reference path="../_all.ts" />


module userAdmin {
  'use strict';



	/**
	 * The main controller for the app. The controller:
	 * - retrieves and persists the model via the todoStorage service
	 * - exposes the model to the template and provides event handlers
	 */
  export class UserAdminDetailCtrl {


    // $inject annotation.
    // it provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // see http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$mdDialog',
      'userAdminService',
      '$timeout',
      '$mdSidenav',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IUserAdminDetailScope,
      private $mdDialog: ng.material.IDialogService,
      private userAdminService: IUserAdminService,
      private $timeout: ng.ITimeoutService,
      private $mdSidenav: ng.material.ISidenavService
    ) {

      $scope.vm = this;
      
      $scope.data = <any>{};
      $scope.working = true;

      $scope.showUnApproved = true;
      $scope.showLocked = false;
      $scope.showRegular = true;


      
      userAdminService.getData()
        .then((response) => {
          this.refreshData(response.data.Users, response.data.Groups, response.data.Permissions);
        })
        .catch((response) => {
          alert("Fehler (Err: " + response.status +")");
        })
        .finally(() => {
          $scope.working = false;
        })

    };

    refreshData(users:{ [name: string] : User }, groups:{ [name: string] : Group }, permissions:{ [name: string] : Permission }) {
      if (users) {
        this.$scope.data.Users = users;
        this.$scope.UserNames = Object.keys(users);
      }
       
      if (groups) {
        this.$scope.data.Groups = groups;
        this.$scope.GroupNames = Object.keys(groups);
      }

      if (permissions) {
        this.$scope.data.Permissions = permissions;
        this.$scope.PermissionNames = Object.keys(permissions);
      }
    }

    close() {      
      this.$mdDialog.cancel();
    }

    cancel() {      
      this.$mdDialog.cancel();
    }


    selectUser(username: string) {
      this.$scope.selectedUser = this.$scope.data.Users[username];
      this.$scope.selectedGroup = null;
      this.$scope.selectedPermission = null;
      this.$scope.groupSearch = this.$scope.permissionSearch = '';      
    }


    selectGroup(groupname: string) {
      this.$scope.selectedUser = null;
      this.$scope.selectedGroup = this.$scope.data.Groups[groupname];
      this.$scope.selectedPermission = null;
      this.$scope.userSearch = this.$scope.permissionSearch = '';  
    }

    selectPermission(permissionname: string) {
      this.$scope.selectedUser = null;
      this.$scope.selectedGroup = null;
      this.$scope.selectedPermission = this.$scope.data.Permissions[permissionname];
      this.$scope.userSearch = this.$scope.groupSearch = '';  
    }

    getUserClass(name) {
      var cls = this.getSelectedClass(name, 'selectedUser', 'UserName');
      if (!this.$scope.data.Users[name].IsApproved) cls += ' unapproved';
      if (this.$scope.data.Users[name].IsLockedOut) cls += ' locked';
      return cls;
    }

    getSelectedClass(item: string, type: string, propName : string) {
      if (this.$scope && this.$scope[type] && this.$scope[type][propName]) {
        if (item === this.$scope[type][propName]) return 'active';
      }
      return null;
    }

    filterUser() {
      return angular.bind(this, function(username) {
        var me : UserAdminDetailCtrl = this;

        if (!me.$scope.showUnApproved   && !me.$scope.data.Users[username].IsApproved) return false;
        if (!me.$scope.showLocked       && me.$scope.data.Users[username].IsLockedOut) return false;
        if (!me.$scope.showRegular      && (!me.$scope.data.Users[username].IsLockedOut && me.$scope.data.Users[username].IsApproved)) return false;

        if (me.$scope.userSearch > '' && username.indexOf(me.$scope.userSearch) < 0) return false;

        //filter by group
        if (me.$scope.selectedGroup) {
          return me.$scope.data.Users[username].Groups.indexOf(me.$scope.selectedGroup.Name) >= 0;
        }

        //filter by permission
        if (me.$scope.selectedPermission) {
          for (var i = 0; i < me.$scope.data.Users[username].Groups.length; i++) {
            var g = me.$scope.data.Users[username].Groups[i];
            if (me.$scope.data.Groups[g].Permissions.indexOf(me.$scope.selectedPermission.Name) >= 0) return true;
          }
          return false;
        }

        return true;
      });   
    }

    filterGroups() {
      return angular.bind(this, function(groupname) {
        var me : UserAdminDetailCtrl = this;

        //filter by user
        if (me.$scope.selectedUser) {
          return me.$scope.selectedUser.Groups.indexOf(groupname) >= 0;
        }

        //filter by permission
        if (me.$scope.selectedPermission) {
          return me.$scope.data.Groups[groupname].Permissions.indexOf(me.$scope.selectedPermission.Name) >= 0;
        }

        return true;
      });   
    }
    
    
    filterPermissions() {
      return angular.bind(this, function(permissionname) {
        var me : UserAdminDetailCtrl = this;
        
        //filter by user
        if (me.$scope.selectedUser) {
          for (var i = 0; i < me.$scope.selectedUser.Groups.length; i++) {
            var g = me.$scope.selectedUser.Groups[i];
            return me.$scope.data.Groups[g].Permissions.indexOf(permissionname) >= 0;
          }
        }

        //filter by group
        if (me.$scope.selectedGroup) {
          return me.$scope.selectedGroup.Permissions.indexOf(permissionname) >= 0;
        }

        return true;
      });   
    }



    /*
     * User Actions
     */
    filterUserNotInRole() {
      return angular.bind(this, function(username) {
        if (!this.$scope.selectedGroup) return null;
        return !((<UserAdminDetailCtrl>this).$scope.data.Users[username].Groups.indexOf((<UserAdminDetailCtrl>this).$scope.selectedGroup.Name) >= 0);
      });   
    }

    addUserToRole(selectUserNameForAdd) {
      var user = this.$scope.data.Users[selectUserNameForAdd]
      var groups = angular.copy(user.Groups);
      groups.push(this.$scope.selectedGroup.Name);

      this.userAdminService.updateUser(user.Id, <UpdateUserData>{"Groups" : groups})
      .then((response) => {
        this.$scope.data.Users[selectUserNameForAdd] = response.data;
        this.$scope.message = "Der User '" + response.data.UserName + "' wurde erfolgreich der Rolle '" + this.$scope.selectedGroup.Name + "' hinzugefügt."
        this.$timeout(() => {this.$scope.message = null}, 6000);
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      }) 
      .finally(() => {
        this.$mdSidenav('user-to-role').close();
      });
    }

    removeUserFromRole(selectUserNameForRemove) {
      var user = this.$scope.data.Users[selectUserNameForRemove]
      var groups = angular.copy(user.Groups);
      var indexOfRole= groups.indexOf(this.$scope.selectedGroup.Name);
      groups.splice(indexOfRole, 1);      

      this.userAdminService.updateUser(user.Id, <UpdateUserData>{"Groups" : groups})
      .then((response) => {
        this.$scope.data.Users[selectUserNameForRemove] = response.data;
        this.$scope.message = "Der User '" + response.data.UserName + "' wurde erfolgreich aus der Rolle '" + this.$scope.selectedGroup.Name + "' entfernt."
        this.$timeout(() => {this.$scope.message = null}, 6000);
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      })       
    }

    
    createUser() {

      this.userAdminService.createUser(this.$scope.newUserData)
      .then((response) => {
        this.$scope.data.Users[response.data.UserName] = response.data;
        this.refreshData( this.$scope.data.Users, null, null);
        this.$scope.message = "Der Benutzer '" + response.data.UserName + "' wurde erfolgreich erstellt."
        this.$timeout(() => {this.$scope.message = null}, 6000);
        this.$mdSidenav('user-new').close();
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      });
    }

    
    updateUser() {

      var data = new UpdateUserData(this.$scope.selectedUser.IsApproved, null, null);

      this.userAdminService.updateUser(this.$scope.selectedUser.Id, data)
      .then((response) => {
        this.$scope.selectedUser = this.$scope.data.Users[this.$scope.selectedUser.UserName] = response.data;        
        this.$scope.message = "Der Benutzer '" + response.data.UserName + "' wurde erfolgreich aktualisiert."
        this.$timeout(() => {this.$scope.message = null}, 6000);
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      }) 
      .finally(() => {
        this.$mdSidenav('user-edit').close();
      });

    }
    
    
    unlockUser() {

      var data = new UpdateUserData(null, false, null);

      this.userAdminService.updateUser(this.$scope.selectedUser.Id, data)
      .then((response) => {
        this.$scope.selectedUser = this.$scope.data.Users[this.$scope.selectedUser.UserName] = response.data;        
        this.$scope.message = "Der Benutzer '" + response.data.UserName + "' wurde erfolgreich entsperrt."
        this.$timeout(() => {this.$scope.message = null}, 6000);
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      }) 
      .finally(() => {
        this.$mdSidenav('user-edit').close();
      });

    }



    /**
     *  Right Sidebar for adding Permissions
     */
    filterNotInSelectedGroup() {
      return angular.bind(this, function(permissionname) {
        if (!this.$scope.selectedGroup) return null;
        return !(this.$scope.selectedGroup.Permissions.indexOf(permissionname) >= 0);
      });   
    }

    addPermission(selectPermissionForAdd) {
      var permissions = angular.copy(this.$scope.selectedGroup.Permissions);
      permissions.push(selectPermissionForAdd);
      var selectedGroup = this.$scope.selectedGroup.Name;

      this.userAdminService.UpdateGroup(this.$scope.selectedGroup.Name, permissions)
      .then((response) => {
        this.refreshData(null, response.data, null);
        this.$scope.selectedGroup = this.$scope.data.Groups[selectedGroup];
        this.$scope.message = "Die Berechtigung '" + selectPermissionForAdd + "' wurde erfolgreich der Gruppe '" + selectedGroup + "' hinzugefügt."
        this.$timeout(() => {this.$scope.message = null}, 6000);
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      }) 
      .finally(() => {
        this.$mdSidenav('permission-add').close();
      });
    }

    
    removePermission(selectPermissionForRemove) {
      var permissions = angular.copy(this.$scope.selectedGroup.Permissions);
      var indexOfPerm = permissions.indexOf(selectPermissionForRemove);
      permissions.splice(indexOfPerm, 1);
      var selectedGroup = this.$scope.selectedGroup.Name;

      this.userAdminService.UpdateGroup(this.$scope.selectedGroup.Name, permissions)
      .then((response) => {
        this.refreshData(null, response.data, null)
        this.$scope.selectedGroup = this.$scope.data.Groups[selectedGroup];
        this.$scope.message = "Die Berechtigung '" + selectPermissionForRemove + "' wurde erfolgreich aus der Gruppe '" + selectedGroup + "' entfernt."
        this.$timeout(() => {this.$scope.message = null}, 6000);
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      }) 
      .finally(() => {
        this.$mdSidenav('permission-add').close();
      });
    }

    
    /**
     *  Right Sidebar for create Permissions
     */

    createPermission() {
      var name = this.$scope.newPermissionData.Name;
      var description = this.$scope.newPermissionData.Desc;

      this.userAdminService.createPermission(name, description)
      .then((response) => {
        this.refreshData(null, null, response.data)
        this.$scope.message = "Die Berechtigung '" + name + "' wurde erfolgreich erstellt."
        this.$timeout(() => {this.$scope.message = null}, 6000);
        this.$mdSidenav('permission-new').close();
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      });
    }

    

    /**
     *  Right Sidebar for adding Roles to Users
     */
    filterRoleNotInSelectedUser() {
      return angular.bind(this, function(rolename) {
        if (!this.$scope.selectedUser) return null;
        return !((<UserAdminDetailCtrl>this).$scope.selectedUser.Groups.indexOf(rolename) >= 0);
      });   
    }

    addRoleToUser(selectRoleForAdd) {
      var groups = angular.copy(this.$scope.selectedUser.Groups);
      groups.push(selectRoleForAdd);
      var user = this.$scope.selectedUser.UserName;

      this.userAdminService.updateUser(this.$scope.selectedUser.Id, <UpdateUserData>{"Groups" : groups})
      .then((response) => {
        this.$scope.selectedUser = this.$scope.data.Users[user] = response.data;        
        this.$scope.message = "Die Rolle '" + selectRoleForAdd + "' wurde erfolgreich dem User '" + user + "' hinzugefügt."
        this.$timeout(() => {this.$scope.message = null}, 6000);
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      }) 
      .finally(() => {
        this.$mdSidenav('role-to-user').close();
      });
    }
    
    removeRoleFromUser(selectRoleForRemove) {
      var groups = angular.copy(this.$scope.selectedUser.Groups);
      var indexOfPerm = groups.indexOf(selectRoleForRemove);
      groups.splice(indexOfPerm, 1);
      var user = this.$scope.selectedUser.UserName;

      this.userAdminService.updateUser(this.$scope.selectedUser.Id, <UpdateUserData>{"Groups" : groups})
      .then((response) => {
        this.$scope.selectedUser = this.$scope.data.Users[user] = response.data;        
        this.$scope.message = "Die Rolle '" + selectRoleForRemove + "' wurde erfolgreich vom User '" + user + "' entfernt."
        this.$timeout(() => {this.$scope.message = null}, 6000);
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      }) 
      .finally(() => {
        this.$mdSidenav('role-to-user').close();
      });
    }

    
    /**
     *  Right Sidebar for adding Roles to Permision
     */
    filterRoleNotInSelectedPermission() {
      return angular.bind(this, function(rolename) {
        if (!this.$scope.selectedPermission) return null;
        return this.$scope.data.Groups[rolename].Permissions.indexOf(this.$scope.selectedPermission.Name) < 0;
      });   
    }

    
    addRoleToPermission(selectRoleForAdd) {
      var groups = this.$scope.GroupNames.filter((groupname) => {
        return this.$scope.data.Groups[groupname].Permissions.indexOf(this.$scope.selectedPermission.Name) >= 0;
      });
      groups.push(selectRoleForAdd);

      this.userAdminService.updatePermission(this.$scope.selectedPermission.Name, groups)
      .then((response) => {
        this.refreshData(null, response.data, null);     
        this.$scope.message = "Der Rolle '" + selectRoleForAdd + "' wurde erfolgreich die Berechtigung '" + this.$scope.selectedPermission.Name + "' erteilt."
        this.$timeout(() => {this.$scope.message = null}, 6000);
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      }) 
      .finally(() => {
        this.$mdSidenav('role-to-permission').close();
      });
    }

    
    removeRoleFromPermission(selectRoleForRemove) {
      var groups = this.$scope.GroupNames.filter((groupname) => {
        return this.$scope.data.Groups[groupname].Permissions.indexOf(this.$scope.selectedPermission.Name) >= 0;
      });
      var indexOfPerm = groups.indexOf(selectRoleForRemove);
      groups.splice(indexOfPerm, 1); 

      this.userAdminService.updatePermission(this.$scope.selectedPermission.Name, groups)
      .then((response) => {
        this.refreshData(null, response.data, null);     
        this.$scope.message = "Der Rolle '" + selectRoleForRemove + "' wurde erfolgreich die Berechtigung '" + selectRoleForRemove + "' entzogen."
        this.$timeout(() => {this.$scope.message = null}, 6000);
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      }) 
      .finally(() => {
        this.$mdSidenav('role-to-permission').close();
      });
    }



    
    createRole() {
      var name = this.$scope.newRoleName;

      this.userAdminService.createGroup(name)
      .then((response) => {
        this.refreshData(null, response.data, null);
        this.$scope.message = "Die Rolle '" + name + "' wurde erfolgreich erstellt."
        this.$timeout(() => {this.$scope.message = null}, 6000);
        this.$mdSidenav('role-new').close();
      })
      .catch((response) => {
        alert("Fehler " + response.data + " (Err: " + response.status +")");
      });
    }




    toggleSidebar(id) {
      this.$mdSidenav(id).toggle();
    }




  }
}